import { Link } from "react-router-dom";

const Row = ({ k, v, testid }) => (
  <div className="flex justify-between gap-3 border-t border-[var(--line)] py-1.5">
    <dt className="text-[var(--stone-dark)]">{k}</dt>
    <dd className="text-right" data-testid={testid}>{v}</dd>
  </div>
);

export const ProjectStatus = ({ project, compact = false, testid = "project-status" }) => (
  <section className={`rounded-xl border border-[var(--line)] bg-white ${compact ? "mt-3 p-3 text-xs" : "mt-6 p-5 text-sm"}`} data-testid={testid}>
    <div className="eyebrow mb-2">Project</div>
    <dl>
      {project.budget && <Row k="Budget" v={project.budget} testid={`${testid}-budget`} />}
      <Row k="Contributors" v={project.supporters} testid={`${testid}-contributors`} />
      <Row k="Owner" v={project.ownerStatus} testid={`${testid}-owner`} />
      <Row k="Support" v={project.supportLabel} testid={`${testid}-support`} />
      <Row k="Funding" v={project.fundsLabel} testid={`${testid}-funds`} />
      {project.testFundsLabel && <Row k="Test mode" v={project.testFundsLabel} testid={`${testid}-test-funds`} />}
    </dl>
    <Link to={`/m/${project.proposalId}`} className="btn-quiet mt-2" data-testid={`${testid}-open`}>View project →</Link>
  </section>
);
